import styles from '../../ProductsRPDesigner.module.scss';
import { colorElements } from '../../responsePage/rptemplate';

function CSColors({ components, changeColor, selectedComponentIndex }) {

  return (
    <>
      {colorElements.map((el) => {
        if (components[selectedComponentIndex]?.[el.name] !== undefined) {
          return (
            <div
              key={el.name}
              className={styles["sec--products--rpdesigner--colors--element"]}
            >
              <div
                className={
                  styles["sec--products--rpdesigner--colors--element--left"]
                }
              >
                {el.label}
              </div>
              <div>
                <input
                  type="color"
                  id={el.name}
                  name={el.name}
                  value={components[selectedComponentIndex]?.[el.name]}
                  onChange={(e) => changeColor(e.target.value, el.name)}
                />
              </div>
            </div>
          );
        }
      })}
    </>
  );
}

export default CSColors;